import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row"
}
const _hoisted_2 = { class: "col-md-8 col-lg-9" }
const _hoisted_3 = { class: "col-md-4 col-lg-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumbItem = _resolveComponent("FKBreadCrumbItem")!
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_ConsentForm = _resolveComponent("ConsentForm")!
  const _component_ConsentVersionsForm = _resolveComponent("ConsentVersionsForm")!
  const _component_ConsentVersionsList = _resolveComponent("ConsentVersionsList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.consent.title
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.consents'),
          to: `/consents`
        }, null, 8 /* PROPS */, ["page"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page"]),
    (!_ctx.has_versions)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_ConsentForm),
          _createVNode(_component_ConsentVersionsForm)
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ConsentForm),
            _createVNode(_component_ConsentVersionsForm)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ConsentVersionsList)
          ])
        ]))
  ], 64 /* STABLE_FRAGMENT */))
}